import React from "react";
import styles from "./index.module.css";

const VehicleCardSkeleton = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.carCardTop}>
        <span className={styles.tagSkeleton}></span>
        <div className={styles.imgSec}>
          <div className={styles.image}></div>
        </div>
        <div className={styles.detailsSec}>
          <div className={styles.name}></div>
          <div className={styles.features}></div>
          <div className={styles.carCardBottom}>
            <div className={styles.carStats}>
              <div className={styles.stat}></div>
              <div className={styles.stat}></div>
              <div className={styles.stat}></div>
            </div>
          </div>
          <div className={styles.cardFooter}>
            <div className={styles.price}></div>
            <div className={styles.moreSec}>
              <div className={styles.viewMore}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleCardSkeleton;